import { Box, Button } from '@mui/material';
import { tss } from 'tss-react/mui';
import { useSignOut } from '../hooks/useSignOut';

const useStyles = tss.create({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

export const SignOut = () => {
  const onLogout = useSignOut();
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Button onClick={onLogout}>Log out</Button>
    </Box>
  );
};
